import React, { useState, useEffect } from "react";
import { Theme } from "../../Helpers/request";
import { Skeleton } from "@mui/material";
import "../../Assets/css/MegaMenu.css";
import MegaMenu from "../Front/themes/newyork/components/Header/MegaMenu";
const Header = () => {
  
  return <MegaMenu />;
};

export default Header;
